// Weapon catalogue.
// Add a new weapon: extend the WEAPONS array. Everything else (HUD, ammo,
// switching, viewmodel, hit registration) reads from here.
export const WEAPONS = {
    rifle: {
        id: "rifle",
        displayName: "AX-7 RIFLE",
        slot: 1,
        hotkey: "Digit1",
        damage: 34,
        magSize: 30,
        reserve: 120,
        fireCooldownMs: 110,
        reloadMs: 1900,
        range: 80,
        // Viewmodel tuning (metres relative to camera)
        model: {
            color: "#1a1f26",
            barrelColor: "#0a0d12",
            gripColor: "#0d1116",
            sightColor: "#00e5ff",
            bodySize: [0.06, 0.1, 0.6],
            barrelLen: 0.35,
            magSize: [0.05, 0.14, 0.08],
            offset: [0.32, -0.25, 0.55],
        },
        sfx: {
            shoot: "shoot_rifle",
            reload: "reload_rifle",
        },
    },
    smg: {
        id: "smg",
        displayName: "VX-9 SMG",
        slot: 2,
        hotkey: "Digit2",
        damage: 22,
        magSize: 30,
        reserve: 150,
        fireCooldownMs: 70,
        reloadMs: 1600,
        range: 45,
        model: {
            color: "#241a26",
            barrelColor: "#0a0d12",
            gripColor: "#181018",
            sightColor: "#c084fc",
            bodySize: [0.06, 0.09, 0.42],
            barrelLen: 0.22,
            magSize: [0.05, 0.18, 0.08],
            offset: [0.30, -0.24, 0.45],
        },
        sfx: {
            shoot: "shoot_smg",
            reload: "reload_smg",
        },
    },
    pistol: {
        id: "pistol",
        displayName: "P-1 SIDEARM",
        slot: 3,
        hotkey: "Digit3",
        damage: 40,
        magSize: 12,
        reserve: 60,
        fireCooldownMs: 220,
        reloadMs: 1300,
        range: 55,
        model: {
            color: "#141920",
            barrelColor: "#0a0d12",
            gripColor: "#0d1116",
            sightColor: "#ffb300",
            bodySize: [0.055, 0.11, 0.22],
            barrelLen: 0.14,
            magSize: [0.045, 0.10, 0.06],
            offset: [0.28, -0.22, 0.32],
        },
        sfx: {
            shoot: "shoot_pistol",
            reload: "reload_pistol",
        },
    },
};

export const WEAPON_ORDER = ["rifle", "smg", "pistol"];
export const DEFAULT_WEAPON = "rifle";

export function getWeapon(id) {
    return WEAPONS[id] || WEAPONS[DEFAULT_WEAPON];
}
